module.exports = __webpack_public_path__ + "assets/img/teacher (36).8e1ed337.png";